import useTranslation from '../../modules/i18n/useTranslation'

const DeadlineComponent = ({ dday }) => {
  const { isLocaleKO } = useTranslation()
  let message

  if (dday > 7) {
    message = isLocaleKO ? '마감 임박' : 'Soon'
  } else if (dday > 0) {
    message = `D-${dday}`
  } else {
    message = isLocaleKO ? '오늘 마감' : 'D-day'
  }

  return <span>{message}</span>
}

export default DeadlineComponent
